import { gu } from "../../../../date-fns/locale/gu.js";
window.dateFns = {
  ...window.dateFns,
  locale: {
    ...window.dateFns?.locale,
    gu
  }
};